import { MeetingStatusEnum } from "enums/MeetingStatusEnum";
import { formatDate, formatDateTime } from "helpers";
import { createLogger } from "logging";
import { MeetingModel } from "models/MeetingModel";
import { PatchMeetingModel } from "models/PatchMeetingModel";
import { createContext } from "react";
import { UseFormReturn } from "react-hook-form";

const logger = createLogger("EditMeetingContext");

export interface MeetingFieldValues {
  title: string;
  location: string;
  eventDate: string;
  endDate: string;
  submissionDate: string;
  note: string;
  status: MeetingStatusEnum;
  locked: boolean;
  isTemplate: boolean;
}

export function getMeetingFieldValues(meeting: MeetingModel): MeetingFieldValues {
  const title = meeting.title || "";
  const eventDate = formatDateTime(meeting.eventDate);
  const endDate = formatDateTime(meeting.endDate);
  const submissionDate = formatDate(meeting.submissionDate);
  const note = meeting.note || "";
  const status = meeting.isDeleted ? MeetingStatusEnum.Deleted : meeting.status;
  const locked = meeting.locked || false;
  const isTemplate = meeting.isTemplate || false;
  const location = meeting.location || "";

  const values = {
    title,
    eventDate,
    endDate,
    submissionDate,
    location,
    note,
    status,
    locked,
    isTemplate,
  };

  logger.debug(`getMeetingFieldValues(): `, values);
  return values;
}

export interface EditMeetingContextProps {
  confirmMeetingUnsaved: boolean;
  setConfirmMeetingUnsaved: (newState: boolean) => void;
  editMeetingId: number;
  setEditMeetingId: (id: number) => void;
  isLoading: boolean;
  isDirty: boolean;
  isValid: boolean;
  isSubmittable: boolean;
  isSubmitting: boolean;
  form: UseFormReturn<MeetingFieldValues>;
  getPatch: (values: MeetingFieldValues) => PatchMeetingModel;
  handleSave: () => Promise<void>;
  handleClose: (ignoreDirty?: boolean) => void;
}

export const EditMeetingContext = createContext({} as EditMeetingContextProps);
